module.exports = __webpack_public_path__ + "static/media/slack.71348306.jpg";